// generate components map
export const constantRouterComponents = {};

const modulesFiles = import.meta.glob('./**/*.ts');

Object.keys(modulesFiles).forEach(async (path) => {
  if (path.startsWith('./index.')) return;
  const value = ((await modulesFiles[path]()) as any).default;

  // mouted
  Object.keys(value).forEach((ele) => {
    constantRouterComponents[ele] = value[ele];
  });
});

console.log('constantRouterComponents', constantRouterComponents);
